import { OWebApp } from "oweb";
import { SXQuestion } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class QuestionsStore extends ServiceStore<SXQuestion> {
	constructor(app: OWebApp) {
		super(app, SXQuestion, "questions");
	}
}
